// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//   FaPlus, FaEdit, FaTrash, FaSave, FaTimes,
//   FaClipboardList, FaSearch, FaChevronLeft,
//   FaChevronRight, FaHistory, FaCalculator
// } from 'react-icons/fa';

// const API_BASE_URL = 'https://cloudapi.emedhatechnologies.com/pages/api/clothingsheets';
// const MASTER_PRODUCTS_URL = 'https://cloudapi.emedhatechnologies.com/pages/api/sheetsmaster';

// const ClothingSheetList = () => {
//   const [sheetLists, setSheetLists] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [masterProducts, setMasterProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Form Data State (including dimensions)
//   const [formData, setFormData] = useState({
//     id: null,
//     sheetName: '',
//     category: 'Cotton',
//     dimensions: '',
//     totalQty: '',
//     unit: 'meters',
//     owner: ''
//   });

//   // Modal States
//   const [cutModalOpen, setCutModalOpen] = useState(false);
//   const [selectedSheetId, setSelectedSheetId] = useState(null);
//   const [cutData, setCutData] = useState({ cutQty: '', customerId: '', note: '' });

//   const [historyModalOpen, setHistoryModalOpen] = useState(false);
//   const [activeSheetHistory, setActiveSheetHistory] = useState(null);

//   const [isEditing, setIsEditing] = useState(false);
//   const [showForm, setShowForm] = useState(false);

//   // Search & Pagination States
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;

//   useEffect(() => {
//     fetchSheets();
//     fetchLeads();
//     fetchMasterProducts();
//   }, []);

//   // 1. Fetch Main Sheets Data
//   const fetchSheets = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_BASE_URL);
//       setSheetLists(res.data);
//     } catch (err) {
//       console.error("Connection error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 2. Fetch Master Products for Dropdown Selection
//   const fetchMasterProducts = async () => {
//     try {
//       const res = await axios.get(MASTER_PRODUCTS_URL);
//       setMasterProducts(res.data);
//     } catch (err) {
//       console.error("Error fetching master products:", err);
//     }
//   };

//   // 3. Fetch CRM Leads for Cut Assignments
//   const fetchLeads = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       if (!user?.id) return;
//       const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
//         params: { user_id: user.id }
//       });
//       const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
//       setCustomers(interestedLeads);
//     } catch (err) {
//       console.error('Error fetching leads:', err);
//     }
//   };

//   // Handle Product Name Selection & Auto-map Category & Dimensions
//   const handleProductSelectChange = (e) => {
//     const selectedName = e.target.value;
//     const foundProduct = masterProducts.find(p => p.sheetName === selectedName);

//     setFormData({
//       ...formData,
//       sheetName: selectedName,
//       category: foundProduct ? (foundProduct.category || 'Cotton') : formData.category,
//       dimensions: foundProduct && foundProduct.dimensions ? foundProduct.dimensions : formData.dimensions
//     });
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleAddNew = () => {
//     setFormData({ id: null, sheetName: '', category: 'Cotton', dimensions: '', totalQty: '', unit: 'meters', owner: '' });
//     setIsEditing(false);
//     setShowForm(true);
//   };

//   // Form Submit Handler (Create / Update)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.sheetName || formData.totalQty === '' || !formData.owner) {
//       alert("Please fill in all required fields (Product Name, Quantity, Owner).");
//       return;
//     }
//     const payload = { ...formData, totalQty: parseFloat(formData.totalQty) };
//     try {
//       if (isEditing) {
//         await axios.put(`${API_BASE_URL}/${formData.id}`, payload);
//       } else {
//         await axios.post(API_BASE_URL, payload);
//       }
//       fetchSheets();
//       setShowForm(false);
//       setFormData({ id: null, sheetName: '', category: 'Cotton', dimensions: '', totalQty: '', unit: 'meters', owner: '' });
//     } catch (err) {
//       console.error("Submit error:", err);
//       alert("Failed to save sheet record");
//     }
//   };

//   const handleEdit = (record) => {
//     setFormData(record);
//     setIsEditing(true);
//     setShowForm(true);
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this master sheet record?")) {
//       try {
//         await axios.delete(`${API_BASE_URL}/${id}`);
//         fetchSheets();
//       } catch (err) {
//         console.error("Delete error:", err);
//         alert("Failed to delete sheet");
//       }
//     }
//   };

//   const openCutModal = (id) => {
//     setSelectedSheetId(id);
//     setCutData({ cutQty: '', customerId: '', note: '' });
//     setCutModalOpen(true);
//   };

//   // Log Cut Transaction
//   const handleCutSubmit = async (e) => {
//     e.preventDefault();
//     const qtyToCut = parseFloat(cutData.cutQty);
//     if (!qtyToCut || qtyToCut <= 0) {
//       alert("Please enter a valid cutting quantity.");
//       return;
//     }

//     if (!cutData.customerId) {
//       alert("Please select an interested lead/customer.");
//       return;
//     }

//     const targetSheet = sheetLists.find(s => s.id === selectedSheetId);
//     const cutsArray = targetSheet.cuts || [];
//     const totalCutAlready = cutsArray.reduce((acc, curr) => acc + parseFloat(curr.cutQty || 0), 0);
//     const remaining = targetSheet.totalQty - totalCutAlready;

//     if (qtyToCut > remaining) {
//       alert(`Cannot cut ${qtyToCut}. Only ${remaining} ${targetSheet.unit} remaining!`);
//       return;
//     }

//     const selectedCustomerObj = customers.find(c => String(c.id) === String(cutData.customerId));
//     const customerName = selectedCustomerObj ? (selectedCustomerObj.name || selectedCustomerObj.customer_name || '') : '';

//     try {
//       await axios.post(`${API_BASE_URL}/${selectedSheetId}/cuts`, {
//         cutQty: qtyToCut,
//         customerId: cutData.customerId,
//         customerName: customerName,
//         note: cutData.note
//       });

//       fetchSheets();
//       setCutModalOpen(false);
//     } catch (err) {
//       console.error("Cut submit error:", err);
//       alert("Failed to log cut entry");
//     }
//   };

//   const openHistory = (sheet) => {
//     setActiveSheetHistory(sheet);
//     setHistoryModalOpen(true);
//   };

//   // Search Filtering
//   const filteredSheets = sheetLists.filter(sheet =>
//     sheet.sheetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     sheet.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     sheet.owner.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     (sheet.dimensions && sheet.dimensions.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   // Pagination Logic
//   const totalPages = Math.ceil(filteredSheets.length / itemsPerPage) || 1;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentSheets = filteredSheets.slice(indexOfFirstItem, indexOfLastItem);

//   return (
//     <div style={{ padding: "12px", fontSize: "12px", fontFamily: "inherit", color: "#1e293b", background: "#f8fafc", minHeight: "100vh", boxSizing: "border-box", width: "100%", overflowX: "hidden" }}>

//       {/* Header Section */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "8px" }}>
//         <div>
//           <h2 style={{ fontSize: "15px", fontWeight: "700", display: "flex", alignItems: "center", gap: "6px", margin: 0, color: "#0f172a" }}>
//             <FaClipboardList color="#2563eb" /> Products & Stock Cut List
//           </h2>
//           <p style={{ fontSize: "11px", color: "#64748b", margin: "2px 0 0 0" }}>Track master stock, map categories, and log cuts linked to leads.</p>
//         </div>
//         {!showForm && (
//           <button onClick={handleAddNew} style={{ display: "flex", alignItems: "center", gap: "5px", backgroundColor: "#2563eb", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>
//             <FaPlus /> Add Master Product
//           </button>
//         )}
//       </div>

//       {/* Search Bar */}
//       <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
//         <div style={{ position: "relative", flex: "1", minWidth: "200px" }}>
//           <FaSearch style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: "11px" }} />
//           <input
//             type="text"
//             placeholder="Search by Product name, category, dimensions, or owner..."
//             value={searchTerm}
//             onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//             style={{ width: "100%", padding: "6px 10px 6px 30px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "5px", outline: "none", background: "#fff", boxSizing: "border-box" }}
//           />
//         </div>
//       </div>

//       {/* Add / Edit Form Drawer */}
//       {showForm && (
//         <div style={{ background: "#ffffff", border: "1px solid #cbd5e1", borderRadius: "6px", padding: "12px", marginBottom: "16px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)" }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", borderBottom: "1px solid #f1f5f9", paddingBottom: "6px" }}>
//             <span style={{ fontWeight: "700", fontSize: "12px", color: "#334155" }}>
//               {isEditing ? "Edit Master Product" : "New Master Product Setup"}
//             </span>
//             <button onClick={() => setShowForm(false)} style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "13px", color: "#64748b" }}><FaTimes /></button>
//           </div>

//           <form onSubmit={handleSubmit} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "10px" }}>

//             {/* Product Name Dropdown (Populated from sheetsmaster) */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Product Name *</label>
//               <select
//                 name="sheetName"
//                 value={formData.sheetName}
//                 onChange={handleProductSelectChange}
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", background: "#fff", boxSizing: "border-box" }}
//               >
//                 <option value="">-- Select Product Name --</option>
//                 {masterProducts.map((prod) => (
//                   <option key={prod.id} value={prod.sheetName}>
//                     {prod.sheetName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Auto-mapped Category (Read-only / Locked based on Product selection) */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Fabric Category (Auto-mapped)</label>
//               <input
//                 type="text"
//                 name="category"
//                 value={formData.category}
//                 readOnly
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", background: "#f1f5f9", color: "#475569", boxSizing: "border-box", cursor: "not-allowed" }}
//               />
//             </div>

//             {/* Extra Dimensions Input */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Dimensions</label>
//               <input
//                 type="text"
//                 name="dimensions"
//                 value={formData.dimensions}
//                 onChange={handleChange}
//                 placeholder="e.g. 50x80 cm or Width 60in"
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }}
//               />
//             </div>

//             {/* Initial Quantity */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Total Initial Qty *</label>
//               <input
//                 type="number"
//                 name="totalQty"
//                 value={formData.totalQty}
//                 onChange={handleChange}
//                 placeholder="e.g. 1000"
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }}
//               />
//             </div>

//             {/* Measurement Unit */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Measurement Unit *</label>
//               <select
//                 name="unit"
//                 value={formData.unit}
//                 onChange={handleChange}
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", background: "#fff", boxSizing: "border-box" }}
//               >
//                 <option value="meters">Meters (m)</option>
//                 <option value="cm">Centimeters (cm)</option>
//                 <option value="yards">Yards (yd)</option>
//                 <option value="inches">Inches (in)</option>
//                 <option value="mm">Millimeters (mm)</option>
//               </select>
//             </div>

//             {/* Owner Field */}
//             <div>
//               <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Owner *</label>
//               <input
//                 type="text"
//                 name="owner"
//                 value={formData.owner}
//                 onChange={handleChange}
//                 placeholder="e.g. John Doe"
//                 style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }}
//               />
//             </div>

//             {/* Form Actions */}
//             <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: "4px" }}>
//               <button type="button" onClick={() => setShowForm(false)} style={{ backgroundColor: "#e2e8f0", color: "#334155", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Cancel</button>
//               <button type="submit" style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#16a34a", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}><FaSave /> Save Product</button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Cut Modal */}
//       {cutModalOpen && (
//         <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "10px" }}>
//           <div style={{ background: "#fff", padding: "16px", borderRadius: "8px", width: "100%", maxWidth: "340px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", boxSizing: "border-box" }}>
//             <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", fontWeight: "700" }}>
//               <span>Cut / Deduct Quantity</span>
//               <button onClick={() => setCutModalOpen(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }}><FaTimes /></button>
//             </div>
//             <form onSubmit={handleCutSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//               <div>
//                 <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Select Interested Lead *</label>
//                 <select value={cutData.customerId} onChange={(e) => setCutData({ ...cutData, customerId: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", background: "#fff", boxSizing: "border-box" }}>
//                   <option value="">-- Choose Interested Lead --</option>
//                   {customers.map((cust) => (
//                     <option key={cust.id} value={cust.id}>
//                       {cust.name || cust.customer_name} {cust.email ? `(${cust.email})` : ''}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Quantity to Cut *</label>
//                 <input type="number" placeholder="e.g. 100" value={cutData.cutQty} onChange={(e) => setCutData({ ...cutData, cutQty: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", boxSizing: "border-box" }} />
//               </div>
//               <div>
//                 <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Note / Reason</label>
//                 <input type="text" placeholder="e.g. Cut for Order #1" value={cutData.note} onChange={(e) => setCutData({ ...cutData, note: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", boxSizing: "border-box" }} />
//               </div>
//               <div style={{ display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: "6px" }}>
//                 <button type="button" onClick={() => setCutModalOpen(false)} style={{ background: "#e2e8f0", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }}>Cancel</button>
//                 <button type="submit" style={{ background: "#2563eb", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", cursor: "pointer", fontWeight: "600" }}>Confirm Cut</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* History Modal */}
//       {historyModalOpen && activeSheetHistory && (
//         <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "10px" }}>
//           <div style={{ background: "#fff", padding: "16px", borderRadius: "8px", width: "100%", maxWidth: "380px", maxHeight: "80vh", overflowY: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", boxSizing: "border-box" }}>
//             <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", fontWeight: "700" }}>
//               <span>Cut Logs: {activeSheetHistory.sheetName}</span>
//               <button onClick={() => setHistoryModalOpen(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }}><FaTimes /></button>
//             </div>
//             {activeSheetHistory.cuts && activeSheetHistory.cuts.length > 0 ? (
//               <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                 {activeSheetHistory.cuts.map((c, index) => (
//                   <div key={c.id || index} style={{ background: "#f8fafc", padding: "8px", borderRadius: "4px", border: "1px solid #e2e8f0", fontSize: "11px" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "600", color: "#dc2626" }}>
//                       <span>Cut #{index + 1}: -{c.cutQty} {activeSheetHistory.unit}</span>
//                       <span style={{ color: "#64748b", fontWeight: "400" }}>{c.date}</span>
//                     </div>
//                     {c.customerName && (
//                       <div style={{ color: "#2563eb", fontWeight: "600", marginTop: "3px" }}>
//                         Customer / Lead: {c.customerName}
//                       </div>
//                     )}
//                     <div style={{ color: "#475569", marginTop: "2px" }}>Note: {c.note}</div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div style={{ textAlign: "center", color: "#94a3b8", padding: "20px" }}>No cuts recorded yet for this sheet.</div>
//             )}
//             <div style={{ textAlign: "right", marginTop: "12px" }}>
//               <button onClick={() => setHistoryModalOpen(false)} style={{ background: "#334155", color: "#fff", border: "none", padding: "5px 12px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Cards Layout Grid */}
//       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "10px" }}>
//         {loading ? (
//           <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "20px", color: "#64748b" }}>Loading database records...</div>
//         ) : currentSheets.length > 0 ? (
//           currentSheets.map((sheet) => {
//             const cutsArray = sheet.cuts || [];
//             const totalCut = cutsArray.reduce((acc, curr) => acc + parseFloat(curr.cutQty || 0), 0);
//             const remaining = sheet.totalQty - totalCut;
//             const percentageUsed = Math.min(Math.round((totalCut / sheet.totalQty) * 100), 100);

//             return (
//               <div key={sheet.id} style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "6px", padding: "10px 12px", boxShadow: "0 1px 2px rgba(0,0,0,0.02)", display: "flex", flexDirection: "column", gap: "6px" }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                   <div>
//                     <span style={{ fontSize: "10px", fontWeight: "700", textTransform: "uppercase", color: "#2563eb", background: "#eff6ff", padding: "1px 5px", borderRadius: "3px" }}>{sheet.category}</span>
//                     <h3 style={{ fontSize: "13px", fontWeight: "700", margin: "4px 0 2px 0", color: "#0f172a" }}>{sheet.sheetName}</h3>
//                     {sheet.dimensions && (
//                       <span style={{ fontSize: "10px", color: "#475569", display: "block", marginTop: "1px" }}>
//                         Dimensions: <strong>{sheet.dimensions}</strong>
//                       </span>
//                     )}
//                   </div>
//                   <span style={{ fontSize: "10px", fontWeight: "600", color: "#64748b" }}>Owner: {sheet.owner}</span>
//                 </div>

//                 <div style={{ fontSize: "11px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "4px", background: "#f8fafc", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
//                   <div>
//                     <span style={{ color: "#94a3b8", display: "block", fontSize: "9px" }}>Initial</span>
//                     <span style={{ fontWeight: "700", color: "#0f172a" }}>{sheet.totalQty}</span>
//                   </div>
//                   <div>
//                     <span style={{ color: "#94a3b8", display: "block", fontSize: "9px" }}>Total Cut</span>
//                     <span style={{ fontWeight: "700", color: "#dc2626" }}>{totalCut}</span>
//                   </div>
//                   <div>
//                     <span style={{ color: "#94a3b8", display: "block", fontSize: "9px" }}>Remaining</span>
//                     <span style={{ fontWeight: "700", color: remaining > 0 ? "#16a34a" : "#dc2626" }}>{remaining} {sheet.unit}</span>
//                   </div>
//                 </div>

//                 <div>
//                   <div style={{ display: "flex", justifyContent: "space-between", fontSize: "9px", color: "#64748b", marginBottom: "2px" }}>
//                     <span>Consumption</span>
//                     <span>{percentageUsed}%</span>
//                   </div>
//                   <div style={{ width: "100%", background: "#e2e8f0", height: "5px", borderRadius: "3px", overflow: "hidden" }}>
//                     <div style={{ width: `${percentageUsed}%`, background: percentageUsed > 80 ? "#dc2626" : "#2563eb", height: "100%", transition: "width 0.3s" }}></div>
//                   </div>
//                 </div>

//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "2px", borderTop: "1px solid #f1f5f9", paddingTop: "6px" }}>
//                   <button onClick={() => openCutModal(sheet.id)} style={{ background: "#dcfce7", color: "#15803d", border: "none", padding: "4px 8px", borderRadius: "4px", fontSize: "11px", cursor: "pointer", display: "flex", alignItems: "center", gap: "3px", fontWeight: "600" }}><FaCalculator size={10} /> Cut Qty</button>
//                   <div style={{ display: "flex", gap: "4px" }}>
//                     <button onClick={() => openHistory(sheet)} style={{ background: "#fef9c3", color: "#a16207", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="View Cut History"><FaHistory size={11} /></button>
//                     <button onClick={() => handleEdit(sheet)} style={{ background: "#eff6ff", color: "#2563eb", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="Edit Product"><FaEdit size={11} /></button>
//                     <button onClick={() => handleDelete(sheet.id)} style={{ background: "#fef2f2", color: "#dc2626", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="Delete Product"><FaTrash size={11} /></button>
//                   </div>
//                 </div>
//               </div>
//             );
//           })
//         ) : (
//           <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "20px", color: "#94a3b8", background: "#fff", borderRadius: "6px", border: "1px solid #e2e8f0" }}>
//             No matching sheets found.
//           </div>
//         )}
//       </div>

//       {/* Pagination Footer */}
//       {filteredSheets.length > itemsPerPage && (
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "16px", background: "#fff", padding: "8px 12px", borderRadius: "6px", border: "1px solid #e2e8f0" }}>
//           <span style={{ fontSize: "11px", color: "#64748b" }}>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredSheets.length)} of {filteredSheets.length} entries</span>
//           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//             <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ display: "flex", alignItems: "center", gap: "3px", background: currentPage === 1 ? "#f1f5f9" : "#eff6ff", color: currentPage === 1 ? "#94a3b8" : "#2563eb", border: "none", padding: "4px 8px", borderRadius: "4px", fontSize: "11px", cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: "600" }}><FaChevronLeft size={10} /> Prev</button>
//             <span style={{ fontSize: "11px", fontWeight: "600", padding: "0 4px" }}>Page {currentPage} of {totalPages}</span>
//             <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={{ display: "flex", alignItems: "center", gap: "3px", background: currentPage === totalPages ? "#f1f5f9" : "#eff6ff", color: currentPage === totalPages ? "#94a3b8" : "#2563eb", border: "none", padding: "4px 8px", borderRadius: "4px", fontSize: "11px", cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: "600" }}>Next <FaChevronRight size={10} /></button>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ClothingSheetList;


































import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  FaPlus, FaEdit, FaTrash, FaSave, FaTimes,
  FaClipboardList, FaSearch, FaHistory, FaCalculator
} from 'react-icons/fa';

const API_BASE_URL = 'https://cloudapi.emedhatechnologies.com/pages/api/clothingsheets';
const MASTER_PRODUCTS_URL = 'https://cloudapi.emedhatechnologies.com/pages/api/sheetsmaster';

// --- Helper Canvas Preview Component ---
// --- Helper Canvas Preview Component ---
const SheetCanvasPreview = ({ sheetDimensions, cuts = [] }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    let masterW = 2000;
    let masterH = 4000;
    if (sheetDimensions) {
      const parts = sheetDimensions.split('x').map(v => parseFloat(v.trim()));
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        masterW = parts[0] > 0 ? parts[0] : 2000;
        masterH = parts[1] > 0 ? parts[1] : 4000;
      }
    }

    const displayWidth = canvas.parentElement.clientWidth || 260;
    // Maintain exact aspect ratio of the master sheet
    const scale = displayWidth / masterW;
    const displayHeight = Math.max(120, masterH * scale);

    canvas.width = displayWidth;
    canvas.height = displayHeight;

    // Draw master sheet background
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#f1f5f9';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#cbd5e1';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);

    // Draw cut pieces inside sheet with correct row packing
    let cursorX = 0;
    let cursorY = 0;
    let currentRowHeight = 0;

    cuts.forEach((cut, index) => {
      if (!cut.cutDimensions) return;
      const cutParts = cut.cutDimensions.split('x').map(v => parseFloat(v.trim()));
      if (cutParts.length !== 2) return;

      const [cWidth, cHeight] = cutParts;
      const qty = parseFloat(cut.cutQty || 1);

      for (let q = 0; q < qty; q++) {
        const drawW = cWidth * scale;
        const drawH = cHeight * scale;

        // Wrap to next row if it exceeds canvas width
        if (cursorX + drawW > canvas.width) {
          cursorX = 0;
          cursorY += currentRowHeight;
          currentRowHeight = 0;
        }

        // Only draw if it fits within the master sheet height
        if (cursorY + drawH <= canvas.height) {
          ctx.fillStyle = index % 2 === 0 ? 'rgba(37, 99, 235, 0.2)' : 'rgba(220, 38, 38, 0.2)';
          ctx.fillRect(cursorX, cursorY, drawW, drawH);

          ctx.strokeStyle = index % 2 === 0 ? '#2563eb' : '#dc2626';
          ctx.lineWidth = 1;
          ctx.strokeRect(cursorX, cursorY, drawW, drawH);

          if (drawW > 25 && drawH > 15) {
            ctx.fillStyle = '#1e293b';
            ctx.font = '8px sans-serif';
            ctx.fillText(`${cWidth}x${cHeight}`, cursorX + 2, cursorY + 10);
          }

          currentRowHeight = Math.max(currentRowHeight, drawH);
          cursorX += drawW;
        }
      }
    });
  }, [sheetDimensions, cuts]);

  return (
    <div style={{ width: '100%', marginTop: '8px', background: '#fff', borderRadius: '4px', overflow: 'hidden', border: '1px solid #e2e8f0', padding: '4px', boxSizing: 'border-box' }}>
      <div style={{ fontSize: '9px', fontWeight: '600', color: '#64748b', marginBottom: '3px', display: 'flex', justifyContent: 'space-between' }}>
        <span>Visual Cut Layout Preview</span>
        <span>{sheetDimensions || 'Custom'}</span>
      </div>
      <canvas ref={canvasRef} style={{ width: '100%', display: 'block', borderRadius: '2px', background: '#f8fafc' }} />
    </div>
  );
};

// --- Main ClothingSheetList Component ---
const ClothingSheetList = () => {
  const [sheetLists, setSheetLists] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [masterProducts, setMasterProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Form Data State
  const [formData, setFormData] = useState({
    id: null,
    sheetName: '',
    category: 'Cotton',
    dimensions: '',
    totalQty: '',
    unit: 'meters',
    owner: ''
  });

  // Modal States
  const [cutModalOpen, setCutModalOpen] = useState(false);
  const [selectedSheetId, setSelectedSheetId] = useState(null);
  const [cutData, setCutData] = useState({ cutQty: '', cutDimensions: '', customerId: '', note: '' });

  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [activeSheetHistory, setActiveSheetHistory] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);

  // Search & Pagination States
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    fetchSheets();
    fetchLeads();
    fetchMasterProducts();
  }, []);

  const fetchSheets = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_BASE_URL);
      setSheetLists(res.data);
    } catch (err) {
      console.error("Connection error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMasterProducts = async () => {
    try {
      const res = await axios.get(MASTER_PRODUCTS_URL);
      setMasterProducts(res.data);
    } catch (err) {
      console.error("Error fetching master products:", err);
    }
  };

  const fetchLeads = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      if (!user?.id) return;
      const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
        params: { user_id: user.id }
      });
      const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
      setCustomers(interestedLeads);
    } catch (err) {
      console.error('Error fetching leads:', err);
    }
  };

  const handleProductSelectChange = (e) => {
    const selectedName = e.target.value;
    const foundProduct = masterProducts.find(p => p.sheetName === selectedName);

    setFormData({
      ...formData,
      sheetName: selectedName,
      category: foundProduct ? (foundProduct.category || 'Cotton') : formData.category,
      dimensions: foundProduct && foundProduct.dimensions ? foundProduct.dimensions : formData.dimensions
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddNew = () => {
    setFormData({ id: null, sheetName: '', category: 'Cotton', dimensions: '', totalQty: '', unit: 'meters', owner: '' });
    setIsEditing(false);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.sheetName || formData.totalQty === '' || !formData.owner) {
      alert("Please fill in all required fields.");
      return;
    }
    const payload = { ...formData, totalQty: parseFloat(formData.totalQty) };
    try {
      if (isEditing) {
        await axios.put(`${API_BASE_URL}/${formData.id}`, payload);
      } else {
        await axios.post(API_BASE_URL, payload);
      }
      fetchSheets();
      setShowForm(false);
    } catch (err) {
      console.error("Submit error:", err);
      alert("Failed to save sheet record");
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this master sheet record?")) {
      try {
        await axios.delete(`${API_BASE_URL}/${id}`);
        fetchSheets();
      } catch (err) {
        console.error("Delete error:", err);
        alert("Failed to delete sheet");
      }
    }
  };

  const openCutModal = (id) => {
    setSelectedSheetId(id);
    setCutData({ cutQty: '', cutDimensions: '', customerId: '', note: '' });
    setCutModalOpen(true);
  };

  const handleCutSubmit = async (e) => {
    e.preventDefault();
    const qtyToCut = parseFloat(cutData.cutQty);

    if (!qtyToCut || qtyToCut <= 0) {
      alert("Please enter a valid cutting quantity.");
      return;
    }

    if (!cutData.customerId) {
      alert("Please select an interested lead/customer.");
      return;
    }

    const targetSheet = sheetLists.find(s => s.id === selectedSheetId);
    if (!targetSheet) {
      alert("Sheet not found.");
      return;
    }

    const selectedCustomerObj = customers.find(c => String(c.id) === String(cutData.customerId));
    const customerName = selectedCustomerObj ? (selectedCustomerObj.name || selectedCustomerObj.customer_name || '') : '';

    try {

      const response = await axios.post(`${API_BASE_URL}/${selectedSheetId}/cuts`, {
        cutQty: qtyToCut,
        cutDimensions: cutData.cutDimensions,
        customerId: cutData.customerId,
        customerName: customerName,
        note: cutData.note
      });


      fetchSheets();
      setCutModalOpen(false);
      setCutData({ cutQty: '', cutDimensions: '', customerId: '', note: '' });
    } catch (err) {
      console.error("Cut submit error:", err);
      const errorMessage = err.response?.data?.error || "Failed to log cut entry";
      alert(errorMessage);
    }
  };

  const openHistory = (sheet) => {
    setActiveSheetHistory(sheet);
    setHistoryModalOpen(true);
  };

  const filteredSheets = sheetLists.filter(sheet =>
    sheet.sheetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    sheet.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    sheet.owner.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (sheet.dimensions && sheet.dimensions.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredSheets.length / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSheets = filteredSheets.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div style={{ padding: "12px", fontSize: "12px", fontFamily: "inherit", color: "#1e293b", background: "#f8fafc", minHeight: "100vh", boxSizing: "border-box", width: "100%", overflowX: "hidden" }}>

      {/* Header Section */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "8px" }}>
        <div>
          <h2 style={{ fontSize: "15px", fontWeight: "700", display: "flex", alignItems: "center", gap: "6px", margin: 0, color: "#0f172a" }}>
            <FaClipboardList color="#2563eb" /> Products & Stock Cut List
          </h2>
          <p style={{ fontSize: "11px", color: "#64748b", margin: "2px 0 0 0" }}>Track master stock, map categories, dimensions, and log cuts linked to leads.</p>
        </div>
        {!showForm && (
          <button onClick={handleAddNew} style={{ display: "flex", alignItems: "center", gap: "5px", backgroundColor: "#2563eb", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>
            <FaPlus /> Add Master Product
          </button>
        )}
      </div>

      {/* Search Bar */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
        <div style={{ position: "relative", flex: "1", minWidth: "200px" }}>
          <FaSearch style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: "11px" }} />
          <input
            type="text"
            placeholder="Search by Product name, category, dimensions, or owner..."
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            style={{ width: "100%", padding: "6px 10px 6px 30px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "5px", outline: "none", background: "#fff", boxSizing: "border-box" }}
          />
        </div>
      </div>

      {/* Add / Edit Form Drawer */}
      {showForm && (
        <div style={{ background: "#ffffff", border: "1px solid #cbd5e1", borderRadius: "6px", padding: "12px", marginBottom: "16px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", borderBottom: "1px solid #f1f5f9", paddingBottom: "6px" }}>
            <span style={{ fontWeight: "700", fontSize: "12px", color: "#334155" }}>
              {isEditing ? "Edit Master Product" : "New Master Product Setup"}
            </span>
            <button onClick={() => setShowForm(false)} style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: "13px", color: "#64748b" }}><FaTimes /></button>
          </div>

          <form onSubmit={handleSubmit} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "10px" }}>
            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Product Name *</label>
              <select
                name="sheetName"
                value={formData.sheetName}
                onChange={handleProductSelectChange}
                style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", background: "#fff", boxSizing: "border-box" }}
              >
                <option value="">-- Select Product Name --</option>
                {masterProducts.map((prod) => (
                  <option key={prod.id} value={prod.sheetName}>{prod.sheetName}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Fabric Category</label>
              <input type="text" name="category" value={formData.category} readOnly style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", background: "#f1f5f9", color: "#475569", boxSizing: "border-box" }} />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Dimensions (e.g., 2000x4000)</label>
              <input type="text" name="dimensions" value={formData.dimensions} onChange={handleChange} placeholder="e.g. 2000x4000" style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }} />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Total Initial Qty *</label>
              <input type="number" name="totalQty" value={formData.totalQty} onChange={handleChange} placeholder="e.g. 1000" style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }} />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Measurement Unit *</label>
              <select name="unit" value={formData.unit} onChange={handleChange} style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", background: "#fff", boxSizing: "border-box" }}>
                <option value="meters">Meters (m)</option>
                <option value="cm">Centimeters (cm)</option>
                <option value="yards">Yards (yd)</option>
                <option value="inches">Inches (in)</option>
              </select>
            </div>

            <div>
              <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Owner *</label>
              <input type="text" name="owner" value={formData.owner} onChange={handleChange} placeholder="e.g. John Doe" style={{ width: "100%", padding: "5px 8px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", outline: "none", boxSizing: "border-box" }} />
            </div>

            <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: "4px" }}>
              <button type="button" onClick={() => setShowForm(false)} style={{ backgroundColor: "#e2e8f0", color: "#334155", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Cancel</button>
              <button type="submit" style={{ display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#16a34a", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}><FaSave /> Save Product</button>
            </div>
          </form>
        </div>
      )}

      {/* Cut Modal */}
      {cutModalOpen && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "10px" }}>
          <div style={{ background: "#fff", padding: "16px", borderRadius: "8px", width: "100%", maxWidth: "340px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", boxSizing: "border-box" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", fontWeight: "700" }}>
              <span>Cut / Deduct Quantity & Dimensions</span>
              <button onClick={() => setCutModalOpen(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }}><FaTimes /></button>
            </div>
            <form onSubmit={handleCutSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div>
                <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Select Interested Lead *</label>
                <select value={cutData.customerId} onChange={(e) => setCutData({ ...cutData, customerId: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", background: "#fff", boxSizing: "border-box" }}>
                  <option value="">-- Choose Interested Lead --</option>
                  {customers.map((cust) => (
                    <option key={cust.id} value={cust.id}>{cust.name || cust.customer_name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Cut Piece Dimensions (e.g. 100x200) *</label>
                <input type="text" placeholder="e.g. 100x200" value={cutData.cutDimensions} onChange={(e) => setCutData({ ...cutData, cutDimensions: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", boxSizing: "border-box" }} />
              </div>

              <div>
                <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Quantity to Deduct *</label>
                <input type="number" placeholder="e.g. 2" value={cutData.cutQty} onChange={(e) => setCutData({ ...cutData, cutQty: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", boxSizing: "border-box" }} />
              </div>

              <div>
                <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "3px", color: "#475569" }}>Note / Reason</label>
                <input type="text" placeholder="e.g. Custom order piece" value={cutData.note} onChange={(e) => setCutData({ ...cutData, note: e.target.value })} style={{ width: "100%", padding: "6px", fontSize: "11px", border: "1px solid #cbd5e1", borderRadius: "4px", boxSizing: "border-box" }} />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: "6px" }}>
                <button type="button" onClick={() => setCutModalOpen(false)} style={{ background: "#e2e8f0", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }}>Cancel</button>
                <button type="submit" style={{ background: "#2563eb", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px", fontSize: "11px", cursor: "pointer", fontWeight: "600" }}>Confirm Cut</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* History Modal */}
      {historyModalOpen && activeSheetHistory && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "10px" }}>
          <div style={{ background: "#fff", padding: "16px", borderRadius: "8px", width: "100%", maxWidth: "380px", maxHeight: "80vh", overflowY: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", boxSizing: "border-box" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", fontWeight: "700" }}>
              <span>Cut Logs: {activeSheetHistory.sheetName}</span>
              <button onClick={() => setHistoryModalOpen(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }}><FaTimes /></button>
            </div>
            {activeSheetHistory.cuts && activeSheetHistory.cuts.length > 0 ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                {activeSheetHistory.cuts.map((c, index) => (
                  <div key={c.id || index} style={{ background: "#f8fafc", padding: "8px", borderRadius: "4px", border: "1px solid #e2e8f0", fontSize: "11px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "600", color: "#dc2626" }}>
                      <span>Cut #{index + 1}: Qty {c.cutQty}</span>
                      <span style={{ color: "#64748b", fontWeight: "400" }}>{c.date}</span>
                    </div>
                    {c.cutDimensions && <div style={{ color: "#0f172a", marginTop: "2px" }}>Size: <strong>{c.cutDimensions}</strong></div>}
                    {c.customerName && <div style={{ color: "#2563eb", fontWeight: "600", marginTop: "2px" }}>Customer: {c.customerName}</div>}
                    <div style={{ color: "#475569", marginTop: "2px" }}>Note: {c.note}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: "center", color: "#94a3b8", padding: "20px" }}>No cuts recorded yet for this sheet.</div>
            )}
            <div style={{ textAlign: "right", marginTop: "12px" }}>
              <button onClick={() => setHistoryModalOpen(false)} style={{ background: "#334155", color: "#fff", border: "none", padding: "5px 12px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Cards Layout Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "10px" }}>
        {currentSheets.map((sheet) => {
          const cutsArray = sheet.cuts || [];

          // 1. Parse Master Dimensions (e.g., "15000 x 20000")
          const masterDims = sheet.dimensions || "0 x 0";
          const [masterWidth, masterHeight] = masterDims.split("x").map(val => parseFloat(val.trim()) || 0);

          // 2. Calculate total cut width and height used (factoring in cutQty)
          let totalCutWidthUsed = 0;
          let totalCutHeightUsed = 0;

          cutsArray.forEach(cut => {
            const qty = parseFloat(cut.cutQty) || 1;
            if (cut.cutDimensions && cut.cutDimensions.includes("x")) {
              const [cWidth, cHeight] = cut.cutDimensions.split("x").map(val => parseFloat(val.trim()) || 0);
              totalCutWidthUsed += cWidth * qty;
              totalCutHeightUsed += cHeight * qty;
            }
          });

          // 3. Compute Remaining Dimensions (cannot go below 0)
          const remainingWidth = Math.max(0, masterWidth - totalCutWidthUsed);
          const remainingHeight = Math.max(0, masterHeight - totalCutHeightUsed);
          const remainingDimsDisplay = `${remainingWidth} x ${remainingHeight}`;

          return (
            <div key={sheet.id} style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "6px", padding: "10px 12px", boxShadow: "0 1px 2px rgba(0,0,0,0.02)", display: "flex", flexDirection: "column", gap: "6px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <span style={{ fontSize: "10px", fontWeight: "700", textTransform: "uppercase", color: "#2563eb", background: "#eff6ff", padding: "1px 5px", borderRadius: "3px" }}>{sheet.category}</span>
                  <h3 style={{ fontSize: "13px", fontWeight: "700", margin: "4px 0 2px 0", color: "#0f172a" }}>{sheet.sheetName}</h3>
                </div>
                <span style={{ fontSize: "10px", fontWeight: "600", color: "#64748b" }}>Owner: {sheet.owner}</span>
              </div>

              {/* METRICS DISPLAY: Master Dimensions & Total Cuts Logged */}
              <div style={{ fontSize: "11px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px", background: "#f8fafc", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                <div>
                  <span style={{ color: "#94a3b8", display: "block", fontSize: "9px" }}>Master Dimensions</span>
                  <span style={{ fontWeight: "700", color: "#0f172a" }}>{masterDims}</span>
                </div>
                <div>
                  <span style={{ color: "#94a3b8", display: "block", fontSize: "9px" }}>Total Cuts Logged</span>
                  <span style={{ fontWeight: "700", color: "#dc2626" }}>{cutsArray.length} Cuts</span>
                </div>
              </div>

              {/* REMAINING DIMENSIONS DISPLAY (Master - Cuts) */}
              <div style={{ fontSize: "11px", background: "#f1f5f9", padding: "6px 8px", borderRadius: "4px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "#64748b", fontWeight: "600", fontSize: "10px" }}>Remaining Dimensions:</span>
                <span style={{ fontWeight: "700", color: "#16a34a" }}>
                  {remainingDimsDisplay}
                </span>
              </div>

              {/* VISUAL CANVAS PREVIEW */}
              <SheetCanvasPreview sheetDimensions={sheet.dimensions} cuts={cutsArray} />

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "2px", borderTop: "1px solid #f1f5f9", paddingTop: "6px" }}>
                <button onClick={() => openCutModal(sheet.id)} style={{ background: "#dcfce7", color: "#15803d", border: "none", padding: "4px 8px", borderRadius: "4px", fontSize: "11px", cursor: "pointer", display: "flex", alignItems: "center", gap: "3px", fontWeight: "600" }}><FaCalculator size={10} /> Cut Qty</button>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button onClick={() => openHistory(sheet)} style={{ background: "#fef9c3", color: "#a16207", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="View Cut History"><FaHistory size={11} /></button>
                  <button onClick={() => handleEdit(sheet)} style={{ background: "#eff6ff", color: "#2563eb", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="Edit Product"><FaEdit size={11} /></button>
                  <button onClick={() => handleDelete(sheet.id)} style={{ background: "#fef2f2", color: "#dc2626", border: "none", padding: "4px 6px", borderRadius: "4px", fontSize: "11px", cursor: "pointer" }} title="Delete Product"><FaTrash size={11} /></button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClothingSheetList;